import { ReactComponent as IconCopy } from '@/assets/svgs/copy.svg'
import { assetUrl } from '@/utils/asset-url'
import Breadcrumbs from '@/components/Breadcrumbs'
import Button from '@/components/Button'
import Portal from '@/components/Portal'
import usePage from '@/hooks/use-page'
import { useNavigate, useLocation } from '@/lib/router-dom'
import { useState } from 'react'


const Page = () => {

	/*=================================================
		General
	/================================================*/

	const [pageTitle, setPageTitle] = useState('Page')

	const { breadcrumbsItems } = usePage({ title: pageTitle, breadcrumbs: [pageTitle, 'Setup New Pitstop', 'Success'] })

	const { goTo } = useNavigate()
	const { currentState } = useLocation()
	const [selfHostedDomains, setSelfHostedDomains] = useState(currentState?.data?.selfHostedDomains);

	function backToHome() {
		goTo('/pitstop')
	}

	const DataTable = ({ itemData }) => {

		const list = itemData.map((item, index) => {
			return (
				<div className="data-table__table__body__row" key={index}>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--heavy data-table__table__body__content--break">
						{item?.domain}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--break">
						{item?.Value}
					</div>
					<div className="data-table__table__body__content data-table__table__body__content--text data-table__table__body__content--break link" onClick={() => navigator.clipboard.writeText(item?.Value)}>
						<IconCopy />

					</div>
				</div>
			)
		})


		return (
			<div className="data-table__content">
				<div className="data-table__content__cols">
					<div className="data-table__content__col">
						<div className="data-table__table">
							<div className="data-table__table__head">
								<div className="data-table__table__head__row">
									<div className={`data-table__table__head__title data-table__table__head__title__sort-order link`}
									>
										Domain
									</div>
									<div className={`data-table__table__head__title data-table__table__head__title__sort-order link`}
									>
										Value
									</div>
									<div className="data-table__table__head__title data-table__table__head__title--flex-end"></div>
								</div>
							</div>
							<div className="data-table__table__body">
								{list}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	return (
		<>
			<div className="layout-feedback">
				<div className="layout-feedback__header">
					{currentState?.mode !== "edit" && (
						<>
							New pitstop request has been submitted successfully
						</>
					)}

					{currentState.mode === "edit" && (
						<>
							Your pitstop has been updated.
						</>
					)}

				</div>
				{selfHostedDomains && selfHostedDomains.length > 0 && <div className="layout-feedback__header">Please add the below values in your DNS records as TXT record</div>}
				{selfHostedDomains && selfHostedDomains.length > 0 && <div className="layout-feedback__header"> for TradeTrust Verification</div>}
				<div className="layout-feedback__content">
					{selfHostedDomains && selfHostedDomains.length > 0 &&
						<DataTable itemData={selfHostedDomains} />
					}
				</div>
				<img src={assetUrl("/img/success.png")} className="card-system__footer" />
				<div className="layout-feedback__footer">
					<Button sizing="Medium" text={'Back to Pitstop'} full round maxWidth="154" submit={backToHome} />
				</div>
			</div>
		</>
	)
}
export default Page
